<script>
    import httpService from '@/services/core/http.service';
    import AdminGrid from '@/components/shared/AdminGrid';
    import { DxColumn, DxItem } from 'devextreme-vue/data-grid';
    import utilsService from '@/services/core/utils.service';

    export default {
        components: {
            AdminGrid,
            DxColumn,
            DxItem
        },
        data() {
            return {
                dataSource: httpService.getDxDataSource('company-usage/grid')
            };
        },
        methods: {
            sendReport() {
                httpService
                    .post(`/company-usage/send-report`)
                    .then(() => {
                        utilsService.showToast('Report sent');
                    })
                    .catch(err => {
                        const response = err.response || err || {};
                        const { message } = response.data || { message: 'An error has ocurred' };

                        utilsService.showToast(message, 'danger');
                    });
            }
        }
    };
</script>

<template>
    <div class="main-content-header">
        <h3>
            <i class="bi bi-percent"></i>
            Company Usage
        </h3>
    </div>
    <div class="main-content-body">
        <AdminGrid :data-source="dataSource" storage-key="company-usage" :show-actions="false">
            <template #toolbar>
                <DxItem location="after" widget="dxButton" :options="{ text: 'Send Report', onClick: sendReport }" />
            </template>

            <DxColumn data-field="createdOn" caption="Created On" data-type="date" sort-order="desc" />
            <DxColumn data-field="year" caption="Year" />
            <DxColumn data-field="month" caption="Period" />
            <DxColumn data-field="company" caption="Company" />
            <DxColumn data-field="monthlyOilProd" caption="Oil Prod" data-type="number" />
            <DxColumn data-field="monthlyGasProd" caption="Gas Prod" data-type="number" />
            <DxColumn data-field="monthlyWaterProd" caption="Water Prod" data-type="number" />
            <DxColumn data-field="activeBatteryCount" caption="Batteries" />
            <DxColumn data-field="activeExecUserCount" caption="Execs" />
            <DxColumn data-field="activePumperUserCount" caption="Pumpers" />
            <DxColumn data-field="activeWaterMeterCount" caption="Meters" />
            <DxColumn data-field="activeWellCount" caption="Wells" />
            <DxColumn data-field="isAllocationsEnabled" caption="Allocations" data-type="boolean" />
            <DxColumn data-field="isDowntimeEnabled" caption="Downtime" data-type="boolean" />
            <DxColumn data-field="isWellTestingEnabled" caption="Well Test" data-type="boolean" />
            <DxColumn data-field="deactivedBatteryCount" caption="Deactivated Batteries" data-type="number" />
            <DxColumn data-field="deactivatedWellsCount" caption="Deactivated Wells" data-type="number" />
        </AdminGrid>
    </div>
</template>
